import { render, staticRenderFns } from "./CarregandoInfo.vue?vue&type=template&id=989b02a8"
import script from "./CarregandoInfo.vue?vue&type=script&lang=ts"
export * from "./CarregandoInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports